import React, { useState, useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import get from 'lodash.get'
import Slider from 'react-slick'
import PropTypes from 'prop-types'
import SVG from 'react-inlinesvg'

import LinkHandler from 'components/atoms/LinkHandler'
import { userCheckMobileScreen } from 'helpers/tools'

import 'slick-carousel/slick/slick.css'
import './CarouselLinks.scss'

function CarouselLinks(props) {
  const { data, className } = props
  const links = get(data, 'links')
  const isCarousel = get(data, 'carousel')
  const accessibilityMode = get(props, 'accessibilityMode', false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    setIsMobile(userCheckMobileScreen())
  })

  const setting = {
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 2,
    arrows: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  }

  function carouselLink(link, icon, token) {
    return (
      <LinkHandler
        to={get(link, 'entity.link.url.path')}
        className="carousel-links-button custom-button btn btn-outline-primary btn-lg"
        id={get(link, 'entity.id')}
      >
        <>
          {icon ? <SVG className="icon" src={icon}></SVG> : <i className={`icone-${token}`} />}
          {get(link, 'entity.link.title')}
        </>
      </LinkHandler>
    )
  }

  function linksList(links, isMobile) {
    return links?.map((link) => {
      const iconSvg =
        get(link, 'entity.linkType.entity.icon.entity.media.entity.fieldMediaFile.entity.url') ||
        get(link, 'entity.icon.entity.media.entity.fieldMediaFile.entity.url')
      const token = get(link, 'entity.linkType.entity.token')

      return isMobile ? (
        carouselLink(link, iconSvg, token)
      ) : (
        <Col lg={'auto'} className="pr-1" key={get(link, 'entity.uuid')}>
          {carouselLink(link, iconSvg, token)}

          <link link={link} icon={iconSvg} token={token} />
        </Col>
      )
    })
  }

  return (
    <Container id={data.id} className={`CarouselLinks ${className || 'py-4'}`}>
      {Array.isArray(links) && isMobile && isCarousel && !accessibilityMode ? (
        // Mobile
        <Slider {...setting}>{linksList(links, isMobile)}</Slider>
      ) : (
        // Desktop
        <Row>{linksList(links, isMobile)}</Row>
      )}
    </Container>
  )
}

CarouselLinks.propTypes = {
  accessibilityMode: PropTypes.bool,
}

export default CarouselLinks
